export default (title = 'Crimson App') => {
  const originalTitle = document.title;
  document.title = title;
  window.print();
  document.title = originalTitle;
};
